//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.8.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum DefinitionElementType {
    Text = 0,
    Number = 1,
    Datepicker = 2,
    Radio = 3,
    Select = 4,
    Array = 5,
    Section = 6,
    Hidden = 7,
    Phone = 8,
    Email = 9,
    ReadOnly = 10,
    Checkbox = 11,
    TextArea = 12,
    Time = 13,
    Button = 14,
    NutsSelector = 15,
    CpvSelector = 16,
    Change = 17,
    InformationBox = 18,
    InputWithDropdown = 19,
    Alert = 20,
    FileUploader = 21,
}

export enum UIDesignElementType {
    Section = 0,
    Subsection = 1,
    LanguageBar = 2,
    LanguageIndicator = 3,
    Role = 4,
    Preview = 5,
    WithheldPublication = 6,
    WithheldPublicationIndicator = 7,
    SubsectionHeader = 8,
    SubSectionInfo = 9,
}

export interface ParentField {
    fieldName: string;
    useSamePath: boolean;
    isArray: boolean;
    isExcluded: boolean;
    singleOptions: string[] | undefined;
}

export interface FormRuleItem {
    message: string | undefined;
    function: string;
    numberValue: number | undefined;
    stringValue: string | undefined;
}

export interface ConditionItem {
    fieldName: string;
    useSamePath: boolean | undefined;
    valueToCompare: string;
    fieldAliasToCompare: string | undefined;
    valueType: ComparisonValueType | undefined;
    compareType: string;
    additionalCompareType: string | undefined;
    logicalOperator: string | undefined;
    conditions: ConditionItem[] | undefined;
    listToCompare: string[] | undefined;
}

export enum ComparisonValueType {
    String = 0,
    Number = 1,
    Boolean = 2,
    Visible = 3,
    Array = 4,
    DateOnly = 5,
    BooleanV2 = 6,
}

export interface ConditionalValidationItem {
    rules: FormRuleItem[] | undefined;
    message: string | undefined;
    logicalExpression: ConditionLogicalExpression | undefined;
}

export interface ConditionLogicalExpression {
    logicalOperator: string | undefined;
    conditions: ConditionItem[] | undefined;
}

export interface RevalidateFields {
    fieldName: string;
    useSamePath: boolean;
}

export interface FormOptionItem {
    value: string;
    label: string;
    addDefaultTag: boolean;
    parentId: string | undefined;
}

export interface ConditionalVisibilityItem {
    logicalExpression: ConditionLogicalExpression | undefined;
}

export interface FormDefinitionItem {
    name: string;
    label: string | undefined;
    tooltip: string | undefined;
    businessTerm: string | undefined;
    placeholder: string | undefined;
    type: DefinitionElementType;
    designElementType: UIDesignElementType | undefined;
    divStyle: string | undefined;
    labelStyle: string | undefined;
    elementStyle: string | undefined;
    sectionStyle: string | undefined;
    fieldsetStyle: string | undefined;
    disabled: boolean | undefined;
    parentField: ParentField | undefined;
    rules: FormRuleItem[] | undefined;
    isDisjunctionConditionList: boolean | undefined;
    conditions: ConditionItem[] | undefined;
    conditionalValidation: ConditionalValidationItem | undefined;
    revalidateFields: RevalidateFields[] | undefined;
    options: FormOptionItem[] | undefined;
    fields: FormDefinitionItem[] | undefined;
    labelAppend: string | undefined;
    labelRemove: string | undefined;
    text: string | undefined;
    preview: boolean | undefined;
    isNumeric: boolean | undefined;
    isArrayLocked: boolean | undefined;
    isMultiSelect: boolean | undefined;
    isSortable: boolean | undefined;
    lockedType: string | undefined;
    arrayItemLocked: boolean | undefined;
    showAsLabel: boolean | undefined;
    translationFileName: string | undefined;
    isTranslatable: boolean | undefined;
    allowToSelectOnlyOne: boolean | undefined;
    isAddingDisabled: boolean | undefined;
    hideArrayItemIndex: boolean | undefined;
    skipClearSelection: boolean | undefined;
    infoIcon: boolean | undefined;
    scheme: string | undefined;
    conditionalVisibility: ConditionalVisibilityItem | undefined;
}